"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.054 10.3-10.059-.03A2 2 0 0 0 6 12v2h12v-2a2 2 0 0 0-.946-1.7z",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.988 5.5a.5.5 0 0 0-.486.383L6.71 9.187a.5.5 0 0 0 .359.6c1.663.44 3.324.659 4.984.659 1.65 0 3.279-.217 4.885-.652a.5.5 0 0 0 .356-.6l-.795-3.31a.5.5 0 0 0-.486-.384H7.988z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.924h4.038M2.5 4v11.924",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M6 14h3v2H6zm9 0h3v2h-3z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 8,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 16,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4A4A4A",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4,
    rx: 1
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgParking);
var _default = exports["default"] = Memo;